var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectManagerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17,
    viewBox: "0 0 16.5 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #707070;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #7d7d7d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9973",
    "data-name": "Group 9973",
    transform: "translate(21838.5 2469.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    cx: 1.233,
    cy: 1.257,
    rx: 1.233,
    ry: 1.257,
    transform: "translate(-21831.146 -2462.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-2",
    d: "M22.687,7.572A3.846,3.846,0,0,1,21.2,4.52a3.748,3.748,0,1,1,7.5,0,3.878,3.878,0,0,1-1.487,3.052",
    transform: "translate(-21854.814 -2469.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173",
    transform: "translate(-21838 -2460.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-3",
    d: "M53.573,1.784a7.971,7.971,0,0,1,3.186,1.873",
    transform: "translate(-43.128 -1.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-4",
    d: "M5.833,0A8.249,8.249,0,0,1,0,7.923",
    transform: "translate(5.833 7.923) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "user-cog",
    className: "cls-5",
    d: "M15.489,9.282a2.038,2.038,0,0,0,0-.74l.448-.259a.126.126,0,0,0,.057-.148,2.607,2.607,0,0,0-.577-1,.127.127,0,0,0-.156-.024l-.448.259A2.039,2.039,0,0,0,14.172,7V6.485a.126.126,0,0,0-.1-.123,2.621,2.621,0,0,0-1.15,0,.126.126,0,0,0-.1.123V7a2.039,2.039,0,0,0-.641.37l-.448-.259a.127.127,0,0,0-.156.024,2.607,2.607,0,0,0-.577,1,.128.128,0,0,0,.057.148l.448.259a2.038,2.038,0,0,0,0,.74l-.448.259A.126.126,0,0,0,11,9.688a2.62,2.62,0,0,0,.577,1,.127.127,0,0,0,.156.024l.448-.259a2.039,2.039,0,0,0,.641.37v.518a.126.126,0,0,0,.1.123,2.621,2.621,0,0,0,1.15,0,.126.126,0,0,0,.1-.123v-.518a2.039,2.039,0,0,0,.641-.37l.448.259a.127.127,0,0,0,.156-.024,2.607,2.607,0,0,0,.577-1,.128.128,0,0,0-.057-.148ZM13.5,9.754a.843.843,0,1,1,.843-.843A.843.843,0,0,1,13.5,9.754Z",
    transform: "translate(-21838 -2464.526)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagerGray);
export default __webpack_public_path__ + "static/media/ProjectManagerGray.4ab8b90c3d3af7bc48689f4f84082842.svg";
export { ForwardRef as ReactComponent };